import { css } from '@emotion/css';

import { HomepageCalendarStates } from './index';

export const CALENDAR_LAYOUT_CONFIG_MAP = {
  ['m-xs']: {
    cellWidth: 58.1,
    cellHeight: 64,
    containerHeight: 470,
  },
  ['s-xs']: {
    cellWidth: 58.1,
    cellHeight: 40,
    containerHeight: 328,
  },
  ['s-s']: {
    cellWidth: 76.1,
    cellHeight: 40,
    containerHeight: 328,
  },
  ['s-m']: {
    cellWidth: 94,
    cellHeight: 40,
    containerHeight: 328,
  },
  ['s-l']: {
    cellWidth: 61.5,
    cellHeight: 40,
    containerHeight: 328,
  },
  ['m-l']: {
    cellWidth: 61.5,
    cellHeight: 64,
    containerHeight: 470,
  },
  ['m-m']: {
    cellWidth: 94,
    cellHeight: 64,
    containerHeight: 470,
  },
  ['m-s']: {
    cellWidth: 76.1,
    cellHeight: 64,
    containerHeight: 470,
  },
} as Record<
  string,
  {
    cellWidth: number;
    cellHeight: number;
    containerHeight: number;
  }
>;

export const getCalendarStyles = ({
  cellWidth,
  cellHeight,
  containerHeight,
  transparentBackground,
}: {
  cellWidth: number;
  cellHeight: number;
  containerHeight: number;
  transparentBackground?: boolean;
}) => {
  const calendarStyles = css`
    .MuiPickersCalendarHeader-label {
      padding-left: 16px;
      font-family: var(--ff-heading-l);
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px;
    }
    .MuiPickersCalendarHeader-root {
      margin-bottom: 8px;
    }
    .MuiPickersDay-root {
      border-radius: 16px;
      margin: 0 0.6rem !important;
      min-width: ${cellWidth}px !important;
      height: ${cellHeight}px !important;
    }
    .MuiCalendarOrClockPicker-root {
      width: 100%;
      min-height: ${containerHeight}px !important;
      margin: 0 0 !important;
    }
    .MuiPickerStaticWrapper-root {
      padding: 0 0 !important;
    }
    .MuiPickerStaticWrapper-root .MuiCalendarOrClockPicker-root > div:first-of-type {
      margin: 0 !important;
      height: 100% !important;
      width: 100% !important;
      min-height: ${containerHeight}px !important;
    }
    .MuiCalendarPicker-root {
      width: 100% !important;
      height: 100% !important;
      min-height: ${containerHeight}px !important;
    }
    .MuiDayPicker-weekDayLabel {
      margin: 0 0.6rem !important;
      min-width: ${cellWidth}px !important;
      height: ${cellHeight}px !important;
      color: var(--text-secondary) !important;
      font-family: var(--fs-heading-xs);
    }

    .MuiPickersArrowSwitcher-root {
      margin-right: 16px;
    }

    .MuiPickersArrowSwitcher-button > svg {
      width: 20px !important;
      height: 20px !important;
    }
    .MuiPickerStaticWrapper-content {
      background-color: ${transparentBackground ? 'transparent' : 'var(--bg-primary)'};
    }
  `;
  return calendarStyles;
};

export const calendarMobileStyles = () => {
  return css`
    .MuiPickersCalendarHeader-label {
      padding-left: 16px;
      font-family: var(--ff-heading-l);
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px;
    }

    .MuiDayPicker-header {
      display: none;
    }

    .MuiDayPicker-slideTransition {
      display: none;
    }
  `;
};

export const getInitialState = (): HomepageCalendarStates => {
  return {
    isUserSelectedDate: false,
    selectedCalendarDate: new Date(Date.now()),
    startingCalendarMonth: new Date(Date.now()),
  };
};

export function createMethods(state: HomepageCalendarStates) {
  return {
    setSelectedCalendarDate(selectedDate: Date) {
      return {
        ...state,
        selectedCalendarDate: selectedDate,
        isUserSelectedDate: true,
      };
    },

    setStartingCalendarMonth(startingMonth: Date) {
      return { ...state, startingCalendarMonth: startingMonth };
    },
  };
}
